import React, { Component, Fragment } from 'react'
import '../roster.css'
import { FormGroup, FormControl, Button, Modal, Table, Row, Col, Dropdown, MenuItem, ControlLabel } from 'react-bootstrap'
import { getParams, makeUniqueKey, end_point, addStatus, generateNewShortLink, sortProgramSessions } from './helper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faPen, faEllipsisH, faPlus, faArrowsAlt, faTimes, faDollarSign, faChevronDown, faInfoCircle, faLink,  } from '@fortawesome/free-solid-svg-icons'
import { faClipboard } from '@fortawesome/free-regular-svg-icons'
import axios from 'axios'
import moment from 'moment'

// Components
import HamburgerNavbar from './hamburgerNavbar'
import Schedule from './RosterMgmtComponents/Schedule'
import EnrolmentPanel from './EnrolmentPanel'
import RosterParticipantsGrid from './RosterParticipantsGrid'
import AthleteMessagesPanel from './AthleteMessagesPanel'


var $ = require('jquery')

class Item extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list_id: this.props.list_id, 
      setDragList : this.props.setDragList, 
      item: this.props.data,
      openModal: false
    }
  }

  drag = (ev) => {
    console.log('dragging', ev.target.id)
    var transferData = JSON.stringify({'from_item_id': ev.target.id, 'from_list_id': this.state.list_id})
    ev.dataTransfer.setData('text/plain', transferData);
  }
  changingModal = () => {
    console.log('changing modal status', this.state.openModal)
    this.setState({ openModal: !this.state.openModal}, () => console.log('setState =', this.state.openModal))
  }

  render() {
    const { openModal } = this.state
    const { data, draggable, plan } = this.props
    var plan_name = data.plan_name ? data.plan_name.length > 35 ? data.plan_name.slice(0, 35) + "..." : data.plan_name : "No plan info"
    var gender = !data.gender || data.gender === "prefer_not_to_say"? "-":data.gender[0].toUpperCase() + data.gender.slice(1)
    var name = `${data.first_name} ${data.last_name}`
    name = name.length > 20? name.slice(0,20) + "...": name
    
    return (           
      <div>
        <div id={data.id} className={data.club_status === 'invited' || data.club_status === 'enrolled' ? "item-global item-club-team" : "item-global"} draggable={draggable} onDragStart={this.drag}
          onClick={()=> this.props.openAthleteModal(data, data.club_status)}
          onDrop={() => {return false }}>
          <div className="item-global-first-row">
            <span>{name}</span>
            {
              !(data.club_status === 'invited' || data.club_status === 'enrolled') && <img draggable='false' src={`${data.status}.png`} className="status-icon"/>
            }
          </div>
          <div className="item-global-second-row">
          <span>{gender} | {data.DOB}</span> 
            {
              data.club_status === "invited" ? <FontAwesomeIcon icon={faDollarSign} color='grey'/> :
                data.club_status === "enrolled" ? <FontAwesomeIcon icon={faDollarSign} color='#4EB363'/>: ""
            }
          </div>
          {
            data.club_status === 'enrolled'? <div className="item-global-second-row">{plan}</div>: <div className="item-global-second-row">{plan_name}</div>
          }
        </div>
      </div>
    )
  }
}

class List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      add : this.props.add,
      remove: this.props.remove,
      list_id : this.props.data.id,
      teamName: this.props.data.name,
      setDragList : this.props.setDragList,
      coach: this.props.data.coach,
      coaches_list: this.props.coaches,
      coachOptions: null,
      addCoach: false,
      expandCoach: false,
      extLeague: this.props.extLeague,
      teamType: this.props.data.team_type,
      rosterSpinner:this.props.rosterSpinner,
      clubTeamData: {
        finalized: this.props.data.clubteam_info? this.props.data.clubteam_info.finalized: false,  
        notes: this.props.data.clubteam_info?this.props.data.clubteam_info.notes: '',
        waiver: this.props.data.clubteam_info?this.props.data.clubteam_info.waiver: 0,
        plan: this.props.data.clubteam_info?this.props.data.clubteam_info.plan: '',
        coaches: this.props.data.clubteam_info?this.props.data.clubteam_info.coaches: []
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    // console.log('<LIST> componentWillReceiveProps:', nextProps)
    this.setState({
      list_id: nextProps.data.id,
      teamName: nextProps.data.name,
      coaches_list: nextProps.coaches,
      coach: nextProps.data.coach,
      rosterSpinner: nextProps.rosterSpinner,
      clubTeamData: nextProps.data.clubteam_info,
      teamType: nextProps.data.team_type
    }, () => {
      this.assignCoach();
    })
  }

  componentDidMount(){
    this.assignCoach();
  }

  assignCoach = () => {
    var temp = [];
    var option = null;
    temp.push(<option value="">Select Coach</option>)
    temp.push(<option value="remove">Remove Coach</option>)
    this.state.coaches_list.forEach(coach => {
      option = <option value={coach._id+","+coach.first_name + "," + coach.last_name}>{coach.first_name + " " + coach.last_name}</option>
      temp.push(option)
    })
    this.setState({ coachOptions: temp });
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  drop(ev) {
    ev.preventDefault();
    var transferData = JSON.parse(ev.dataTransfer.getData('text/plain')) // DataTransfer object holds data during a dnd
    var to_list_id = this.state.list_id
    if (transferData.from_list_id != to_list_id) {
      this.state.add(transferData.from_list_id,transferData.from_item_id,to_list_id)
      this.state.remove(transferData.from_item_id,transferData.from_list_id)
    }
  }

  removeTeam = (id) => {
    if(window.confirm("Delete this group?")){
      if (this.props.editMode) {
        console.log("editMode", this.props.editMode)
        this.props.openCloseListEditWindows(this.state.list_id)
      }
      console.log("this.props.deleteTeam")
      this.props.deleteTeam(id);
    }
  }

  emailTeam = (id) => {
    this.props.emailTeam(id)
  }

  editTeam = () => {
    this.props.openCloseListEditWindows(this.state.list_id)
  }

  exitEditMode(){
    this.props.editName(this.state.list_id, this.state.teamName)
    this.props.openCloseListEditWindows(this.state.list_id)
  }

  handleEditMode = (event) => {
    this.setState({ teamName: event.target.value });
  }

  saveClub = () => {
    this.props.saveClubTeamInfo(this.state.list_id, this.state.clubTeamData)
    this.exitEditMode()  
  }

  saveGroup = () => {
    this.props.editName(this.state.list_id, this.state.teamName)
    this.exitEditMode()
  }

  handleCoachChange = (e) => {
    this.props.editCoach(this.state.list_id, e.target.value)
    this.setState({ coach: e.target.value });
  }

  handleClubTeamCoachChange = (e, index) => {
    var clubTeamData = this.state.clubTeamData
    e.target.value === 'remove' ? clubTeamData.coaches.splice(index, 1) : clubTeamData.coaches[index] = e.target.value 
    this.setState({ clubTeamData })  
  }

  handlePlanChange = (e) => {
    var clubTeamData = this.state.clubTeamData
    clubTeamData.plan = e.target.value
    this.setState({ clubTeamData })
  }

  handleTeamTypeChange = (e) => {
    if(this.state.teamType === 'Club Team' && e.target.value === 'Group'){
      if(window.confirm(`Switch from Club Team to Group?`)){
        this.setState({ teamType: e.target.value })
        this.props.changeTeamType(this.state.list_id, e.target.value)
      }
    } else {
      this.setState({ teamType: e.target.value })
      this.props.changeTeamType(this.state.list_id, e.target.value)  
    }
  }

  renderTeamType = () => {
    var returnType = []
    let types = ['Group', 'Club Team']
    types.forEach((type) =>{
      returnType.push(<option value={type} key={type}>{type}</option>)
        })
    return returnType
  }

  onChangeClubWaiver = (e) => {
    var clubTeamData = this.state.clubTeamData
    clubTeamData.waiver = e.target.value
    this.setState({ clubTeamData })
  }

  renderPlans = () => {
    var returnPlan = []
    returnPlan.push(<option value=''>Please Select</option>)
    this.props.plans.forEach((plan) =>{
        returnPlan.push(<option value={plan._id}>{plan.plan_name} - {plan.plan_price} {plan.instalments && plan.instalments.length !== 0 ? '*monthly instalment available' : ''}</option>)
      })
  return returnPlan
  }

  // renderWaivers = () => {
  //   var returnWaivers = []
  //   returnWaivers.push(<option value=''>Please Select</option>)
  //   [''].forEach((plan) =>{
  //       returnPlan.push(<option value={plan._id}>{plan.plan_name} - {plan.plan_price} {plan.instalments && plan.instalments.length !==0? '*monthly instalment available': ''}</option>)
  //     })
  // return returnPlan
  // }


  addClubTeamCoach = () => {
    var coachNumber = this.state.clubTeamData.coaches.length 
    if(coachNumber === 0){ 
      alert('Please select a coach.')
    } else if (this.state.clubTeamData.coaches[coachNumber - 1] === ''){
      alert('Please select a coach.')
    } else {
      var clubTeamData = this.state.clubTeamData
      clubTeamData.coaches.push('')
      this.setState(clubTeamData)
    }
  }

  handleNotesChange = (e) => {
    var clubTeamData = this.state.clubTeamData
    clubTeamData.notes = e.target.value
    this.setState({ clubTeamData })
  }

  finalizeRoster = () => {
    const { list_id } = this.state
    this.props.saveClubTeamInfo(list_id, this.state.clubTeamData)
    this.props.editName(list_id, this.state.teamName)
    var allAthleteEnrolled = true
    this.props.data.items.forEach(athlete => {
      if (athlete.status !== 'enrolled'){
        allAthleteEnrolled = false
      }
    })
    var check = null
    if(this.state.clubTeamData.plan === ''){
      alert('Select a plan')
      check = false
    } else if (this.state.clubTeamData.coaches.length === 0){
      alert('Select a coach')
      check = false
    } else if (allAthleteEnrolled === false) {
      alert('All players must have status of Enrolled before a roster is finalized.')
      check = false
    } else {
      check = true
    }
    if (check) {
      this.props.finalizeRoster(list_id)
      this.props.openCloseListEditWindows(this.state.list_id)
    }
  }

  coachExpand = () => {
    this.setState({ expandCoach: true})
  }

  coachCollapse = () => {
    this.setState({ expandCoach: false})
  }


  render() {
    const { list_id, clubTeamData, teamType, rosterSpinner, teamName, coach, coachOptions, extLeague } = this.state
    const { data, editMode, openAthleteModal } = this.props
    var listClassName 
    var clubteamPlan = null
    if(list_id === 0 ) {
      listClassName = 'list-global list-normal-enrolment'
    } else if (editMode && teamType ==='Club Team') {
      listClassName = 'list-global list-club-team-edit'
    } else if (data.clubteam_info && data.clubteam_info.finalized) {
      listClassName = 'list-finalized'
      this.props.plans.forEach(plan => {
        if(plan._id === data.clubteam_info.plan) {
          clubteamPlan = plan.plan_name
        }
      })
    } else {
      listClassName = 'list-global list-normal'
    }

    return (
      <div id={list_id} className={listClassName} onDrop={!(clubTeamData&& clubTeamData.finalized) && this.drop.bind(this)}  onDragOver={!(clubTeamData&& clubTeamData.finalized) && this.allowDrop}>
        { list_id !== 0 ? (
          <div className="club-menu" style={{align: "center", margin: '0'}}>
            <Dropdown className="pull-right team-ellipsis" id="team-dropdown" style={{backgroundColor: "transparent"}}>
              <Dropdown.Toggle as={this.customToggle} className="ellipsis-dropdown" id="dropdown-custom-components">
                <a><FontAwesomeIcon icon={faEllipsisH} size="2x" color='white' className="team-ellipsis" /></a>
              </Dropdown.Toggle>
              <Dropdown.Menu className="ellipsis-menu">
                {
                  !extLeague &&
                  <MenuItem className="li-item" onClick={()=>this.editTeam()}>Edit</MenuItem>
                }
                
                <MenuItem className="li-item" onClick={()=>this.emailTeam(list_id)}>Email</MenuItem>
                {
                  !(data.clubteam_info && data.clubteam_info.finalized) && 
                  <MenuItem className="li-item" onClick={()=>this.removeTeam(list_id)}>Delete</MenuItem>
                }
                
              </Dropdown.Menu>
            </Dropdown>
          </div>
          ): ""
        }
        { list_id !== 0 && editMode &&
          <div>
            <span className="bucket-title">Group Type</span>
            <FormControl className="opaque-grey buck-form-field" onChange={this.handleTeamTypeChange} name="teamType" id="teamType" value={teamType} componentClass="select">
              {this.renderTeamType()}
            </FormControl>
            
          </div>
        }
        <div style={{overflow: "hidden", width: "100%"}}>
          { editMode === false ? rosterSpinner && rosterSpinner.list_id === list_id && rosterSpinner.status ?
            <div className="enrolment-loader"></div> : 
              <Fragment>
                <div>
                  {teamName === 'Enrolment' ? 'Enrolled Players': teamName}
                  {
                    !(data.clubteam_info && data.clubteam_info.finalized) && list_id !== 0 && <a onClick={()=>this.editTeam()} style={{cursor: "pointer", paddingLeft: '0.5em' }}>
                        <Fragment>
                          <FontAwesomeIcon icon={faPen} color='white' size="xs"/>&nbsp;&nbsp;
                        </Fragment>
                    </a>
                  }
                </div>
                {
                  extLeague && <div className="org-name">{this.props.data.org_name}</div>
                }
              </Fragment>
              : (
                <div>
                  <div className="margin-top-4">
                    {/* <span className="bucket-title">{teamType} Name</span> */}
                    <FormGroup className="margin-top-4">
                    <FormControl className="opaque-grey buck-form-field" id="team_name" componentClass="input" value={teamName} onChange={this.handleEditMode} onKeyPress={event => event.key === 'Enter' ? this.props.editName(list_id, teamName) : "" } />
                    </FormGroup>
                  </div>
                  <div className="margin-top-4 pull-right">                  
                  <Button className="rostersbutton" onClick={this.saveGroup}>
                    Save
                  </Button>
                </div>
               </div>
                )
          }
          {
          data.club && 
          <div className="club-name">{data.club}</div>
          }
        </div>
        { list_id !== 0 && teamType === 'Group'? editMode ?
          <div>
            <span className="bucket-title">Coach&nbsp;</span>
            <div className="margin-top-4 bucket-center">
              <FormControl className="opaque-grey buck-form-field" onChange={this.handleCoachChange} value={coach} name="coach" id="coach" componentClass="select">
                {coachOptions}
              </FormControl>
            </div>
            <div className="margin-top-4 pull-right">
              <Button className="rostersbutton" onClick={this.saveGroup}>
                Save
              </Button>
            </div>
          </div> : <div className="bucket-left" style={{fontSize: '11px'}}>{coach.split(',')[1]} {coach.split(',')[2]}</div>
          : ""
        }
        { list_id !== 0 && teamType === 'Club Team'? editMode ?
          <div>
            <span className="bucket-title">Coach&nbsp;</span>
            { clubTeamData && clubTeamData !== undefined && clubTeamData.coaches.length === 0 ?
              <div className="margin-top-4">
                <FormControl className="opaque-grey buck-form-field" onChange={(e)=>this.handleClubTeamCoachChange(e, 0)} name="coach" id="coach" componentClass="select">
                  {coachOptions}
                </FormControl>
              </div> : 
              clubTeamData.coaches.map((coach, index) => {
                return(
                  <div className="margin-top-4">
                    <FormControl  className="opaque-grey buck-form-field" onChange={(e)=>this.handleClubTeamCoachChange(e, index)} name="coach" id="coach" value={coach} componentClass="select">
                      {coachOptions}
                    </FormControl>
                  </div>
                )
              })
            }
            <div className="margin-top-4 bucket-center">
              <Button className="margin-top-4 rostersbutton" onClick={this.addClubTeamCoach}>Add Coach</Button>
            </div>
          </div> : 
          <div className="bucket-left" style={{fontSize: '11px'}}>
            { clubTeamData && clubTeamData.coaches.length > 0 && this.state.expandCoach ?
              <div>
                { clubTeamData.coaches.map((coach, index) => {
                  return (
                    index === 0 ?
                      <div className="bucket-left">
                        HC: {clubTeamData.coaches[0].split(',')[1]} {clubTeamData.coaches[0].split(',')[2]}&nbsp;&nbsp;<FontAwesomeIcon onClick={this.coachCollapse} icon={faChevronDown} />
                      </div> :
                      <div className="bucket-left">{coach.split(',')[1]} {coach.split(',')[2]}</div> 
                    )
                  })
                }
              </div> :
              clubTeamData && clubTeamData.coaches[0] && 
              <div>
                HC: {clubTeamData.coaches[0].split(',')[1]} {clubTeamData.coaches[0].split(',')[2]}&nbsp;&nbsp;
                { clubTeamData.coaches.length > 1 && <FontAwesomeIcon onClick={this.coachExpand} icon={faChevronDown} />}
              </div>
            }
          </div>
          : ""
        }
        {
          editMode && teamType === 'Club Team' && 
          <div>
            <div>
              <span className="margin-top-4 bucket-title">Team Details:&nbsp;</span>
              <FormControl placeholder="notes" className="opaque-grey buck-form-field" name="clubteam_notes" componentClass="textarea" id={"clubteam_notes"} onChange={this.handleNotesChange} 
                defaultValue={clubTeamData.notes} rows={4} />
            </div>
            <div>
              <span className="margin-top-4 bucket-title">Plans:&nbsp;</span>
              <FormControl style={{marginTop: '2%'}} className="opaque-grey buck-form-field" onChange={this.handlePlanChange} name="teamType" id="teamType" value={clubTeamData.plan} componentClass="select">
                {this.renderPlans()}
              </FormControl>
            </div>
            <div>
              <span className="margin-top-4 bucket-title">Waiver:&nbsp;</span>
              <FormControl style={{marginTop: '2%'}} className="opaque-grey buck-form-field" onChange={this.onChangeClubWaiver} name="teamType" id="teamType" value={clubTeamData.waiver} componentClass="select">
                <option value=''>Please Select</option>
                <option value='0'>Org. Waiver</option>
                <option value='1'>Travel Waiver</option>
              </FormControl>
            </div>
            <div className="margin-top-4 pull-right">
              <Button className="margin-top-4 rostersbutton" onClick={this.saveClub}>
                Save
              </Button>
            </div>
            <br></br>
            <div className="margin-top-4 bucket-center">
              <Button className="margin-top-4 rostersbutton" onClick={()=> this.finalizeRoster()}>
                Finalize Roster
              </Button>
            </div>
          </div>
        }
        { list_id !==0 && editMode && <hr /> }
        <div className="margin-top-4"></div>
        { 
          (clubTeamData && clubTeamData.finalized && data) ? data.items.map(item => 
            <Item data={item} draggable={false} plan={clubteamPlan} list_id={list_id} openAthleteModal={openAthleteModal} key={makeUniqueKey()} />
          ) : data.items.map(item =>
            <Item data={item} draggable={true} list_id={list_id} openAthleteModal={openAthleteModal} key={makeUniqueKey()}/>
          )
        }
      </div>
    );
  }
}


class Board extends Component {
  constructor(props) {
    super(props)
    const queryToken = getParams().jwt
    const storedToken = typeof window !== 'undefined' ? localStorage.getItem('jwt') : ''
    const token = queryToken && queryToken !== 'undefined' ? queryToken : storedToken
    const rosterConversationStorageKey = `rosterMessagingConversation.${localStorage.getItem("organization_id") || 'unknown'}.${getParams().program_id || 'unknown'}`
    const storedConversationKey = localStorage.getItem(rosterConversationStorageKey)
    const rosterViewStorageKey = `rosterView.${localStorage.getItem("organization_id") || 'unknown'}.${getParams().program_id || 'unknown'}`
    const storedRosterView = localStorage.getItem(rosterViewStorageKey) || 'participants'
    this.state = {
      all_players: [],
      all_programs: [],
      apparel_info: [],
      auto_assign: false,
      auto_assign_team_count: null,
      coaches: [],
      currently_editing_list: [],
      enrolmentData: {},
      extLeague: null,
      last_saved: "",
      lists: [],
      link_modal: false,
      player_info: [],
      player_modal: false,
      programs: [],
      program_id: getParams().program_id,
      programUDFS: null,
      plans: [],
      organization_id: localStorage.getItem("organization_id"),
      organization_name: null,
      organization_merch: [],
      rosterSpinner: {list_id: null, status: false},
      rosters_endpoint: `${end_point()}/rosters/1`,
      selected_program: null,
      selected_athlete: null,
      show_apparel_modal: false,
      rosterView: storedRosterView,
      rsvps_endpoint: `${end_point()}/rsvps`,
      rsvps: [],
      rsvps_loading: false,
      scheduleMonth: moment().startOf('month'),
      selected_group_conversation_key: storedConversationKey,
      status_spinner: false,
      status_options: [],
      transfer_spinner: false,
      team_options: [],
      teamData: [],
      teamIndex: null,
      token,
      toSave: true,
      transferProgramRoster: [],
      transfer_to_program: null,
      transfer_to_team: '',
      transferTypeHint: false,
      transferType: null,
    }
    this.rosterConversationStorageKey = rosterConversationStorageKey
    this.rosterViewStorageKey = rosterViewStorageKey
  }

  persistRosterConversationKey = (conversationKey) => {
    if (!this.rosterConversationStorageKey || typeof window === 'undefined') {
      return
    }

    if (conversationKey) {
      localStorage.setItem(this.rosterConversationStorageKey, conversationKey)
    } else {
      localStorage.removeItem(this.rosterConversationStorageKey)
    }
  }

  persistRosterView = (rosterView) => {
    if (!this.rosterViewStorageKey || typeof window === 'undefined') {
      return
    }

    localStorage.setItem(this.rosterViewStorageKey, rosterView)
  }

  // TRY TO RESOLVE ALL CALLS CONCURRENTLY  https://medium.com/swlh/concurrency-async-await-and-promise-all-in-javascript-ed617c41cb52
  
  loadPage = async () => {
    const { program_id, organization_id } = this.state
    var rthis = this;
    if (!program_id) {
      window.alert("Please Select a Program");
      window.location.href = document.location.origin + "/programRosters?jwt=" + this.state.token;
    }
    
    this.loadRoster()

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": organization_id,
        "program_id": program_id,
      },
      method: "GET",
      dataType: "json",
      url: `${end_point()}/plans`,
    }).then(data => rthis.setState({ plans: data.message[0].plans}))

    axios.get(`${end_point('programs')}/programs`, {
      headers: {
        "token": this.state.token,
        "organization_id": organization_id,
        "alphabetize": true
      },
    }).then(response => {
      // ----- ADD STATUS OF PROGRAM -----
      var temp_data = addStatus(response.data)
      var activePrograms = temp_data.message.filter(program => program.status !== "Expired")
      // ---------------------------------
      console.log("Active Programs:", activePrograms)
      rthis.setState({all_programs: activePrograms })
    })

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": organization_id,
        "user_type": "coachadmin"
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('users')}/users`,
    }).then(data => rthis.setState({ coaches: data.message }) )

    axios.get(`${end_point('organizations')}/organizations`, {
      headers: {
        "token": this.state.token,
        "organization_id": organization_id
      },
    }).then(data => {
      const orgData = data && data.data ? data.data : {}
      const merch = Array.isArray(orgData.merch) ? orgData.merch : []
      console.log("org data", orgData)
      rthis.setState({ 
        organization_name: orgData.name || '',
        organization_merch: merch})
    })
  }

  loadRoster = () => {
    var rthis = this
    var data = {
      token: this.state.token,
      program_id: this.state.program_id,
      organization_id: this.state.organization_id
    }
    
    console.log('data - about to /get rosters', data)
    $.ajax({
      data: data,
      method: "GET",
      dataType: "json",
      url: this.state.rosters_endpoint,
      success: function(data){
        if(data.errorMessage){
          alert(data.errorMessage)
        } else {
          setInterval(rthis.saveToDatabase, 600000) // autosave every 10 min
          console.log("BACK FROM /GET ROSTERS", data.message)
          rthis.handleAllUsers(data.message.roster)
          var program = data.message.program || {}
          var enrolledUsers = Array.isArray(program.enrolled_users) ? program.enrolled_users : []
          program = {
            ...program,
            enrolled_users: enrolledUsers,
            plans: Array.isArray(program.plans) ? program.plans : [],
            sessions: Array.isArray(program.sessions) ? program.sessions : []
          }
          rthis.getSpots(program)
          rthis.handleApparelInfo(enrolledUsers)
          var udfs = program.udfs && program.udfs.length > 0 ? program.udfs : null
            rthis.setState({
              selected_program: program,
              player_info: enrolledUsers,
              programUDFS: udfs,
              extLeague: program.type === "rep league" || program.type === "tournament" ? true : false
            }, rthis.loadRsvps)
        }
      },
      error: function(err){
        console.log('what is the error - from board.js', err)
        window.alert("Please log in");
        window.location.href = document.location.origin + "/login";
      }
    })
  }

  loadRsvps = () => {
    if (!this.state.program_id || !this.state.organization_id || !this.state.token) {
      return
    }
    this.setState({ rsvps_loading: true })
    axios.get(this.state.rsvps_endpoint, {
      params: {
        token: this.state.token,
        organization_id: this.state.organization_id,
        program_id: this.state.program_id,
      },
    }).then((response) => {
      this.setState({
        rsvps: response && response.data && Array.isArray(response.data.message) ? response.data.message : [],
        rsvps_loading: false,
      })
    }).catch((error) => {
      console.log('Unable to load RSVPs', error)
      this.setState({ rsvps: [], rsvps_loading: false })
    })
  }

  handleRosterRsvpChange = (athleteId, session, event) => {
    const response = event && event.target ? event.target.value : ''
    const sessionKey = `${session.date}-${session.start_time}-${session.type}`
    if (!response) {
      return
    }

    this.setState((previousState) => {
      const existing = Array.isArray(previousState.rsvps) ? previousState.rsvps : []
      const nextRsvps = existing.filter((rsvp) => `${String(rsvp.athlete_id)}:${rsvp.session_key}` !== `${String(athleteId)}:${sessionKey}`)
      nextRsvps.push({
        athlete_id: athleteId,
        session_key: sessionKey,
        response,
      })
      return { rsvps: nextRsvps }
    })

    axios.patch(this.state.rsvps_endpoint, {
      token: this.state.token,
      organization_id: this.state.organization_id,
      program_id: this.state.program_id,
      athlete_id: athleteId,
      session_key: sessionKey,
      session_date: session.date,
      session_type: session.type,
      session_start_time: session.start_time,
      session_end_time: session.end_time,
      session_location: session.location,
      response,
    }, {
      headers: { token: this.state.token },
    }).catch((error) => {
      console.log('Unable to save roster RSVP', error)
    })
  }

  shiftRsvpMonth = (amount) => {
    this.setState((previousState) => ({
      scheduleMonth: previousState.scheduleMonth.clone().add(amount, 'month').startOf('month'),
    }))
  }

  resetRsvpMonth = () => {
    this.setState({ scheduleMonth: moment().startOf('month') })
  }

  componentDidMount() {
    this.loadPage()
  }

  // ================= TRANSFER PLAYER FNS ===================
  createOptions = (type, data) => {
    console.log("IN CREATE OPTIONS")
    console.log('type=',type)
    console.log('data=',data)
    var options = []
    var option = type === 'program_options' ? 'program' : 'team'
    console.log('option=',option)
    options.push(<option key={`${type}-placeholder`} value="" disabled>Pick a {option}</option>)

    data.forEach((val, index) => {
      options.push(
        <option key={makeUniqueKey()} value={type === 'team_options' ? index : val._id}>
          {type ==='program_options' ? `${val.group_name} | ${val.ages} | ${val.division} | ${val.season}` : val.name}
        </option>)
    })
    console.log('OPTIONS=',options)
    this.setState({ [type]: options })
  }

  getTransferProgramOptions = () => {
    const currentProgramId = this.state.program_id ? this.state.program_id.toString() : ''
    const options = [<option key="program-placeholder" value="" disabled>Pick a program</option>]
    const programs = Array.isArray(this.state.all_programs) ? this.state.all_programs : []

    programs
      .filter((program) => program && program._id && program._id.toString() !== currentProgramId)
      .forEach((program) => {
        options.push(
          <option key={program._id.toString()} value={program._id.toString()}>
            {`${program.group_name} | ${program.ages} | ${program.division} | ${program.season}`}
          </option>
        )
      })

    return options
  }

  selectProgramTransfer = async (val) => {
    console.log("IN SELECT PROGRAM TRANSFER")
    var transfer = this.state.all_programs.find(program => {
      return program._id === val
    })
    console.log('program selected:', transfer)

    // NEED TO FIND ROSTER FOR TRANSFERRING PROGRAM TO CREATE TEAM OPTIONS

    let rosters = await axios.get(this.state.rosters_endpoint, {
      params: {
        token: this.state.token,
        program_id: transfer._id,
        organization_id: this.state.organization_id
      }
    })
    console.log("!!! ROSTER AXIOS RESULT",rosters)
    console.log("!!!! teams=",rosters.data.message.roster.teams)
    this.createOptions('team_options', rosters.data.message.roster.teams)
    this.setState({ transferProgramRoster: rosters.data.message.roster.teams})
    this.setState({transfer_to_program: transfer})
  }

  selectTeamTransfer = (val) => {
    if (!val) {
      this.setState({ teamIndex: null })
      return
    }
    var teamIndex = Number(val)
    this.setState({ teamIndex: Number.isNaN(teamIndex) ? null : teamIndex })
  }

  handleTransferPlayer = async () => {
    const { transferType, transfer_to_program, teamIndex, selected_athlete } = this.state
    console.log("selected_athlete - handleTransferPlayer", selected_athlete)
    if (selected_athlete.status !== "enrolled") {
      window.alert("Only enrolled athletes are allowed to be transfered")
    } else if (!transferType || !transfer_to_program || teamIndex === null) {
      var message = ""
      
      if (!transferType) {
        message = 'an action.'
      } else if (!transfer_to_program) {
        message = 'a program to transfer to.'
      } else {
        message = 'a team.'
      }
      window.alert(`Please choose ${message}`)
    } else {
      if(window.confirm(`Are you sure you would like to ${transferType} this player`)) {
        this.setState({transfer_spinner: true })
        // send to BE to transfer player
        const response = await axios.put(this.state.rosters_endpoint, {
          data: {
            "token": this.state.token,
            "organization_id": this.state.organization_id,
            "player": this.state.selected_athlete,
            "targetProgram": transfer_to_program,
            "currentProgram": this.state.program_id,
            "team": teamIndex,
          },
          status: "transfer",
          transferType: transferType
        })
        .then(response => {
          console.log('Transfer response', response)
          this.setState({
            transfer_spinner: false,
            player_modal: false
          })
          this.loadPage()        
        })
        .catch(error => {
          console.log(error)
          window.alert("Something went wrong. Contact support@hoopstir.com")
          this.setState({ transfer_spinner: false })
        })
      }
    }
  }

  // ====================================
  
  handleAllUsers = (resp) => {
    console.log('look at index of teams', resp)
    const teams = resp && Array.isArray(resp.teams) ? resp.teams : []
    teams.forEach(team => {
      if(team.coach){
        team.coach = `${team.coach._id},${team.coach.first_name},${team.coach.last_name}`
      } else if (team.clubteam_info) {
        var tempArr = []
        const clubTeamCoaches = Array.isArray(team.clubteam_info.coaches) ? team.clubteam_info.coaches : []
        clubTeamCoaches.length > 0 && clubTeamCoaches.forEach(coach => {
          tempArr.push(`${coach._id},${coach.first_name},${coach.last_name}`)
        })
        team.clubteam_info.coaches = tempArr
      }
    })
    this.setState({lists: teams});
  }

  handleApparelInfo = (data) => {
    if (!Array.isArray(data)) {
      this.setState({ apparel_info: [] })
      return
    }
    var enrolled = []
    var invited = []
    var waitlist = []
    data.forEach(athlete => {
      if (!athlete.status || athlete.status === 'enrolled') {
        enrolled.push(athlete)
      } else if ( athlete.status === 'invited') {
        invited.push(athlete)
      } else if (athlete.status === 'waitlist' ) {
        waitlist.push(athlete)
      } else {
      }
    })
    
    var apparel_info = enrolled.concat(invited, waitlist)
    console.log("apparel_info", apparel_info)
    this.setState({ apparel_info })
  }


    // saveToDatabaseForFinalizeRoster = () => {
    //   this.saveToDatabaseCallBack((err, success)=> {
    //     if(err){
    //       return false
    //     } else {
    //       return true
    //     }
    //   })
    // }

  openCloseListEditWindows = (id) => {
    let currentList = this.state.currently_editing_list
    let currentListIndex = currentList.indexOf(id)
    let newList = currentList
    if (currentListIndex > -1) {
      newList.splice(currentListIndex, 1)
      this.setState({currently_editing_list: newList})
    } else {
      newList.push(id)
      this.setState({currently_editing_list: newList})
    }
  }

  saveToDatabaseCallBack = (callback) => {
    var rthis = this;
    var temp_lists = this.state.lists.slice(0);
    temp_lists.unshift({'organization_id':this.state.organization_id, 'program_id': this.state.program_id})
    console.log('JSON.stringify(temp_lists)', JSON.stringify(temp_lists))
    if (this.state.lists) {
      $.ajax({
        headers: {},
        method: "PUT",
        contentType: 'application/json',
        data: JSON.stringify(temp_lists),
        url: this.state.rosters_endpoint,
        success: function (data) {
          if (data.errorMessage) {
            alert(data.errorMessage);
            callback('unable to save', null)
          } else {
            rthis.setState({last_saved: new Date()})
            callback(null, 'success!')
          }
        },
        error: function (data){
          callback('unable to save', null)
          alert("Please Contact Support!")
        }
      })
    }
  }

  saveToDatabase = () => {
    var rthis = this;
    var temp_lists = this.state.lists.slice(0);
    temp_lists.unshift({'organization_id':this.state.organization_id, 'program_id': this.state.program_id})
    console.log('saveToDatabase', temp_lists)
    temp_lists.forEach(list => {
      if (list.items) {
        list.items.forEach(item => {
          for (var key in item) {
            if (key !== "_id" && key !== "first_name" && key !== "last_name" && key !== "id" && key !== "number") {
              delete item[key]
            }
          }
        })
      }
    })
    if (this.state.lists && this.state.toSave === true) {
      $.ajax({
        headers: {},
        method: "PUT",
        contentType: 'application/json',
        data: JSON.stringify(temp_lists),
        url: `${end_point()}/rosters/1`,
        success: function (data) {
          if (data.errorMessage) {
            alert(data.errorMessage);
          } else {
            console.log('returning back from saving to db', data)
            rthis.setState({
              last_saved: new Date(),
              player_modal: false
            })
            rthis.loadRoster()
          }
        },
        error: function (error) {
          console.log('save to DB error', error)
          const errorMessage = error && error.responseJSON
            ? (error.responseJSON.Error || error.responseJSON.errorMessage || error.responseJSON.message)
            : null
          alert(`Error: ${errorMessage || 'Unable to save roster changes'}`)
        }
      })
    }
  }
  
  removeFromList = (item_id,list_id) => {
    let filteredArray = this.state.lists[list_id].items.filter(item => item.id != item_id)
    var updatedLists = this.state.lists
    updatedLists[list_id].items = filteredArray
    this.setState({lists : updatedLists})
  }

  addToList = (from_list_id,from_item_id,to_list_id) => {
    from_item_id = Number(from_item_id)
    let filteredItem = this.state.lists[from_list_id].items.filter(function(item){
      return item.id == from_item_id
      }
    )
    this.state.lists[to_list_id].items = [...this.state.lists[to_list_id].items, filteredItem[0]]
  }

  addNewTeam(){
    var temp_lists = this.state.lists;
    temp_lists.push({'id':temp_lists.length, 'name':'Group Name', coach: '', items:[]})
    this.setState({lists: temp_lists})
  }

  deleteTeam = (id) => {
    var temp_lists = this.state.lists.slice();
    var temp_players = [];
    temp_lists.forEach((list, index) => {
      if(list.id === id){
        temp_lists.splice(index, 1);
        if(list.items.length !== 0){
          temp_players = list.items;
        }
      }
    })

    if (temp_players.length !== 0) {
      temp_lists[0].items = temp_lists[0].items.concat(temp_players)
    } 
    
    for(var i = 1; i < temp_lists.length; i ++){
      temp_lists[i].id = i
    }
    this.setState({lists: temp_lists})
  }

  editName = (id, name) => {
    var temp_lists = this.state.lists;
    temp_lists.forEach(list => {
      if(list.id === id){
        list.name = name;
      }
    })
    this.setState({lists: temp_lists})
  }

    editCoach = (id, coach) => {
      var temp_lists = this.state.lists;
      temp_lists.forEach(list => {
        if(list.id === id){
          list.coach = coach;
        }
      })
      this.setState({lists: temp_lists})
    }

    saveClubTeamInfo = (id, clubTeamInfo) => {
      this.setState({ toSave: false })
      var temp_lists = this.state.lists;
      temp_lists.forEach(list => {
        if (list.id === id) {
          list.clubteam_info = clubTeamInfo
        }
      })

      this.saveToDatabaseCallBack((err, success) => {
        err ? alert('Unable to save this club team, please contact support') : this.setState({ lists: temp_lists, toSave: true })
      })
    }
    

  changeTeamType = (id, teamType) => {
    var temp_lists = this.state.lists;
    temp_lists.forEach(list => {
      if (list.id === id) {
        if (teamType==='Group' && list.clubteam_info) {
          delete list.clubteam_info
        }
        list.team_type = teamType
        list.clubteam_info = {
          finalized: false,
          notes: this.state.selected_program && this.state.selected_program.additional_notes
            ? this.state.selected_program.additional_notes
            : '',
          plan: "",
          waiver: 0,
          coaches: []
        }
      }
    })
    this.setState({lists: temp_lists})
  }

  emailTeam = (teamID) => {
    console.log('emailTeam', this.state, 'teamID', teamID)
    window.location.href = window.location.origin + "/notifications?jwt=" + this.state.token + "&organization_id=" + this.state.organization_id + "&program_id=" + this.state.program_id + "&toTeams=" +  teamID;
  }

  autoAssign = () => {
    this.setState({ auto_assign: true })
  }

  exitTeamCountChange(){
    if(window.confirm(`By auto-assigning this program's enrollees any currently assigned players will be re-assigned .  Still use auto-assign?`)){
      this.setState({ auto_assign: false});
      this.makeTeams(this.state.auto_assign_team_count)
    }
  }

  makeTeams(number){
    var new_lists = new Array(parseInt(number)+1);
    new_lists[0] = {
      id: 0,
      name: 'Enrolment',
      items: []
    }
    for(var i = 1 ; i <= number; i ++){
      new_lists[i] = {
        id: i,
        name: `team ${i}`,
        coach: '',
        teamType: 'Group',
        items: []
      };
    }

    var all_players = [];
    var other_players = [];
    this.state.lists.forEach(data => {
      if(data.items.length !== 0){
        data.items.forEach(player => {
          player.status === 'enrolled'? all_players.push(player): other_players.push(player)
        })
      }
    })

    if(number == 0){
      new_lists[0].items = all_players.concat(other_players)
    } else {
      var sort_team = 1;
      new_lists[0].items = other_players
      while(all_players.length !== 0){
        var random_player = Math.floor(Math.random() * all_players.length)
        new_lists[sort_team].items.push(all_players[random_player]);
        all_players.splice(random_player, 1);
        if(sort_team < number){
          sort_team += 1;
        } else {
          sort_team = 1;
        }
      }
    }
    this.setState({lists: new_lists})
  }

  enterAssignTeamPress(e){
    if(e.keyCode == 13){
      this.exitTeamCountChange();
    }
  }

  openApparelModal = () => {
    this.setState({ show_apparel_modal: true })
  }

  openAthleteModal = (data, club_status) => {
    this.setState({
      transferType: '',
      transfer_to_program: null,
      teamIndex: null,
      selectedStatus: data.status || '',
      team_options: []
    })

    var status_options = []
    var status_selections 
    (club_status === 'enrolled' || club_status === 'invited') ? status_selections = ['enrolled', 'withdrawn']
    :
    status_selections = ['enrolled', 'waitlist',  'invited', 'withdrawn']

    status_selections.forEach(status => {
      status_options.push(<option key={makeUniqueKey()} value={status}>{status.charAt(0).toUpperCase() + status.slice(1)}</option>)
    })

    // ------ remove current program from options ------
    console.log("selected athlete:", data)
    this.setState({ 
      selected_athlete: data,
      player_modal: true,
      status_options
    })
  }

  handleModal = type => {
    const { selected_program, organization_id } = this.state
    var program = [selected_program]
    if(type === 'link_modal') {
      // generate links
      this.setState({ newShortLink: "Creating Short Link..."})
      var encodeSearch = encodeURIComponent(
        selected_program && selected_program.group_name
          ? selected_program.group_name.toLowerCase()
          : ''
      )
      var org_name = encodeURIComponent(this.state.organization_name)
      program.forEach(async prog => {
        let link = ''
        if (prog.type === "rep league" || prog.type === "tournament") {
          link = `login?organization_id=${organization_id}&organization_name=${org_name}&redirectedUser=true&search=${encodeSearch}&extLeague=true` 
        } else {
          link = `login?organization_id=${organization_id}&organization_name=${org_name}&redirectedUser=true&search=${encodeSearch}`
        }
        this.setState({ newLink: `${document.location.origin}/${link}`})
        var newShortLink = await generateNewShortLink(link)
        this.setState({ newShortLink })
      })
    }
    this.setState({[type]: !this.state[`${type}`]})
  }

  getSpots = (program) => {
    if (!program) {
      this.setState({
        enrolmentData: {
          enrolled: 0,
          spots: 0,
          invited: 0,
          max: 0,
          remaining: 0,
          flex: 0
        }
      })
      return
    }
    var temp = {}
    var enrolled = 0
    var invited = 0
    var flex = program.enrolment_flex ? program.enrolment_flex : 0
    var enrolledUsers = Array.isArray(program.enrolled_users) ? program.enrolled_users : []
    enrolledUsers.forEach(user => {
      if(user.status === 'enrolled') enrolled += 1
      if(user.status === 'invited') invited += 1
    })
    temp.enrolled = enrolled
    temp.spots = program.enrollment_maximum + flex - enrolled
    temp.invited = invited
    temp.max = program.enrollment_maximum
    temp.remaining = program.enrollment_maximum - enrolled
    temp.flex = flex

    this.setState({ enrolmentData: temp })
  }

  setEditMode = (id) => {
    return (this.state.currently_editing_list.indexOf(id) > -1)
  }

  handleAthleteStatusSubmit(){
    var rthis = this
    var status = document.getElementById("status").value
    var goAhead = true
    if(status === ''){
      this.setState({ player_modal: false })
    } else {
      var message = ''
      switch (status){
        case "withdrawn":
          message = 'A Withdrawn athlete will no longer appear on this page.  Are you sure you want to Withdraw this athlete?'
          break;
        case "enrolled":
          message = 'Are you sure you want to Enrol this athlete?'
          break;
        case "waitlist":
          message = 'Are you sure you want to Waitlist this athlete?'
          break;
        case "invited":
          const { enrolmentData } = this.state
          if(enrolmentData.spots <= 0){
            message = `There are no spots available, please adjust your enrolment flex`
            goAhead = false
          } else {
            message = `There are currently ${enrolmentData.spots} spots available and ${enrolmentData.invited} invited athletes.  Would you like to continue?`
          }
          break;
      }
      if(window.confirm(message) && goAhead ){
        this.setState({ status_spinner: true})
        var data = {
          "status": status,
          "token": this.state.token,
          "program_id": this.state.program_id,
          "organization_id": this.state.organization_id,
          "athlete_id": this.state.selected_athlete._id,
          "number": this.state.selected_athlete.number
        }
        console.log('going to update roster', data, JSON.stringify(data))
        $.ajax({
          headers: {},
          method: "PUT",
          contentType: 'application/json',
          data: JSON.stringify(data),
          url: `${end_point()}/rosters/1`,
          success: function (data) {
            if (data.errorMessage) {
              alert(data.errorMessage)
              rthis.setState({ status_spinner: false })
            }
            else {
              rthis.setState({last_saved: new Date(), player_modal: false, status_spinner: false})
              rthis.loadPage()
            }
          },
          error: function (data){
            console.log("error:", data);
            alert("Please Contact Support!")
            rthis.setState({ status_spinner: false })
          }
        })
      } else {
        this.setState({ player_modal: false })
      }
    }
  }

  finalizeRoster = async (list_id) => {
    var rthis = this
    if(window.confirm("A Finalized Roster cannot be edited - Make sure all details are correct before you press OK!  Are you ready to invite these players to pay their team fees and join the team?")){
      var rosterSpinner = this.state.rosterSpinner
      rosterSpinner.list_id = list_id 
      rosterSpinner.status = true
      this.setState({ toSave: false, rosterSpinner})
      this.saveToDatabaseCallBack((err, success)=>{
        if(success){
          var data = {
            "status": "finalizeroster",
            "token": this.state.token,
            "program_id": this.state.program_id,
            "organization_id": this.state.organization_id,
            "list_id": list_id,
          }
          $.ajax({
                method: "PUT",
                contentType: 'application/json',
                data: JSON.stringify(data),
                url: `${end_point()}/rosters/1`,
                success: function (data) {
                  if (data.errorMessage) {
                    alert(data.errorMessage)
                    var rosterSpinner = rthis.state.rosterSpinner
                    rosterSpinner.list_id = null 
                    rosterSpinner.status = false
                    rthis.setState({ rosterSpinner, toSave: true })
                  }
                  else {
                    var rosterSpinner = rthis.state.rosterSpinner
                    rosterSpinner.list_id = null 
                    rosterSpinner.status = false
                    rthis.setState({ rosterSpinner, toSave: true })
                    alert(data.message)
                    window.location.reload(true);
                  }
                },
                error: function (data){
                  //console.log(data);
                  var rosterSpinner = rthis.state.rosterSpinner
                  rosterSpinner.list_id = null 
                  rosterSpinner.status = false
                  rthis.setState({ rosterSpinner, toSave: true })
                  alert("Please Contact Support!")
                }
            })
          }
      })
    }
  }

  customToggle = () => {
    return (
      <a href=""></a>
    )
  }

  findAthleteDetails = (data) => {
    var athleteUDFs = null
    this.state.lists.map(list => {
      var findAthlete = list.items.find(item => { return item._id === data._id})
      if (findAthlete && findAthlete.udfs) {
        athleteUDFs = findAthlete.udfs
      }
    })
    return athleteUDFs
  }

  renderRosterActions = () => {
    return (
      <Row className="rostersecondrow">
        <Col xs={12} lg={12}>
          <div className="right-btns">
            <a onClick={this.addNewTeam.bind(this)}><FontAwesomeIcon icon={faPlus} style={{width: ""}}/></a>
            {
              this.state.auto_assign === false ?
                <a onClick={this.autoAssign.bind(this)}><FontAwesomeIcon icon={faArrowsAlt} /></a>
                :
                <div style={{textAlign: "center"}}>
                  <div style={{textAlign: "center",}}>How many teams? Press Enter</div>
                  <FormGroup>
                    <FormControl className="opaque-grey" id="auto_assign_team_count" componentClass="input"
                      value={this.state.auto_assign_team_count}
                      onChange={(e) => this.setState({auto_assign_team_count: e.target.value})}
                      onBlur={this.exitTeamCountChange.bind(this)}
                      onKeyDown={this.enterAssignTeamPress.bind(this)}
                    />
                  </FormGroup>
                </div>
            }
            <a onClick={() => this.handleModal('show_apparel_modal')}><FontAwesomeIcon icon={faClipboard} style={{width: "1em"}} /></a>
            <a onClick={() => this.handleModal('link_modal')}><FontAwesomeIcon icon={faLink} /></a>

            <Dropdown id="ellipsis-dropdown">
              <Dropdown.Toggle as={this.customToggle} className="ellipsis-dropdown center" id="dropdown-custom-components">
                <a style={{marginLeft: '0.2em' }}><FontAwesomeIcon icon={faChevronDown} /></a>
              </Dropdown.Toggle>
              <Dropdown.Menu className="team-ellipsis-menu test-left">
                <MenuItem className="li-item" href={window.location.origin + "/notifications?jwt=" + this.state.token + "&organization_id=" + this.state.organization_id + "&program_id=" + this.state.program_id}>
                  Send notification to event
                </MenuItem>
                <MenuItem className="li-item" onClick={() => this.handleModal('show_apparel_modal')}>
                  See participant details
                </MenuItem>
              </Dropdown.Menu>
            </Dropdown>

            <Button className="rostersbutton" onClick={this.saveToDatabase} style={{ marginLeft: "1%", width: '10%'}}>
              Save Work
            </Button>
          </div>
        </Col>
      </Row>
    )
  }

  renderRosterBoard = () => {
    return (
      <>
        {this.renderRosterActions()}
        <div className="roster-board">
          {
            this.state.extLeague !== null && this.state.lists &&
            this.state.lists.map((list, index) => {
              if (index === 0) {
                return(
                  <div className="enrolment-board" key={makeUniqueKey()}>
                    <List data={list}
                      key={makeUniqueKey()}
                      add={this.addToList}
                      coaches={this.state.coaches}
                      editCoach={this.editCoach}
                      deleteTeam={this.deleteTeam}
                      remove={this.removeFromList}
                      editName={this.editName}
                      openAthleteModal={this.openAthleteModal}
                      editMode={false}
                      extLeague={this.state.extLeague}
                    />
                  </div>
                )
              }
              return null
            })
          }

          <div className="team-board">
            {
              this.state.extLeague !== null && this.state.lists &&
              this.state.lists.map((list, index) => {
                if(index !== 0){
                  return(
                    <List data={list}
                      key={index}
                      add={this.addToList}
                      coaches={this.state.coaches}
                      plans={this.state.plans}
                      rosterSpinner={this.state.rosterSpinner}
                      editCoach={this.editCoach}
                      deleteTeam={this.deleteTeam}
                      remove={this.removeFromList}
                      editName={this.editName}
                      openAthleteModal={this.openAthleteModal}
                      saveClubTeamInfo={this.saveClubTeamInfo}
                      emailTeam={this.emailTeam}
                      changeTeamType={this.changeTeamType}
                      finalizeRoster={this.finalizeRoster}
                      editMode={this.setEditMode(list.id)}
                      openCloseListEditWindows={this.openCloseListEditWindows}
                      extLeague={this.state.extLeague}
                    />
                  )
                }
                return null
              })
            }
          </div>
        </div>
      </>
    )
  }

  renderRsvpView = (participantRows, selectedProgram) => {
    const allSessions = selectedProgram && Array.isArray(selectedProgram.sessions)
      ? sortProgramSessions(selectedProgram.sessions).filter((session) => session && session.date)
      : []
    const month = this.state.scheduleMonth.clone().startOf('month')
    const sessions = allSessions.filter((session) => moment(session.date).isSame(month, 'month'))
    const rsvpMap = (this.state.rsvps || []).reduce((map, rsvp) => {
      map[`${String(rsvp.athlete_id)}:${rsvp.session_key}`] = rsvp.response
      return map
    }, {})

    if (this.state.rsvps_loading) {
      return <div className="roster-rsvp-empty">Loading RSVPs...</div>
    }
    if (!allSessions.length) {
      return <div className="roster-rsvp-empty">No dated sessions are available for RSVP.</div>
    }

    return (
      <div className="roster-rsvp-panel">
        <div className="roster-rsvp-heading">
          <div>
            <div className="parent-portal-section-title">RSVPs</div>
            <h3 className="parent-calendar-title">{month.format('MMMM YYYY')}</h3>
            <div className="roster-rsvp-copy">Session responses for this program.</div>
          </div>
          <div className="parent-calendar-actions">
            <Button className="parent-calendar-button" onClick={() => this.shiftRsvpMonth(-1)}>Previous</Button>
            <Button className="parent-calendar-button" onClick={this.resetRsvpMonth}>Today</Button>
            <Button className="parent-calendar-button" onClick={() => this.shiftRsvpMonth(1)}>Next</Button>
          </div>
        </div>
        <div className="roster-rsvp-table-wrap">
          {sessions.length ? <table className="roster-rsvp-table">
            <thead>
              <tr>
                <th>Player</th>
                {sessions.map((session) => {
                  const sessionKey = `${session.date}-${session.start_time}-${session.type}`
                  const estimatedAttendance = participantRows.reduce((count, participant) => {
                    const athleteId = participant._id && participant._id.toString ? participant._id.toString() : participant._id
                    return rsvpMap[`${String(athleteId)}:${sessionKey}`] === 'Yes' ? count + 1 : count
                  }, 0)
                  return (
                    <th key={sessionKey}>
                      <span className="roster-rsvp-attendance">Attending: {estimatedAttendance}</span>
                      <span>{new Date(session.date).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}</span>
                      <small>{session.type || 'Session'}</small>
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {participantRows.map((participant) => {
                const athleteId = participant._id && participant._id.toString ? participant._id.toString() : participant._id
                return (
                  <tr key={athleteId}>
                    <th>{participant.first_name} {participant.last_name}</th>
                    {sessions.map((session) => {
                      const sessionKey = `${session.date}-${session.start_time}-${session.type}`
                      const response = rsvpMap[`${athleteId}:${sessionKey}`] || ''
                      const responseClass = response === 'Yes' ? 'yes' : response === 'No' ? 'no' : response === 'Maybe' ? 'maybe' : ''
                      return (
                        <td key={sessionKey}>
                          <div className="parent-rsvp-control">
                            <span className={`parent-rsvp-dot ${responseClass}`} aria-hidden="true" />
                            <FormControl
                              className="parent-rsvp-select"
                              componentClass="select"
                              value={response}
                              onChange={(event) => this.handleRosterRsvpChange(athleteId, session, event)}
                            >
                              <option value="" disabled>Select</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                              <option value="Maybe">Maybe</option>
                            </FormControl>
                          </div>
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table> : <div className="roster-rsvp-empty">No sessions are scheduled for {month.format('MMMM YYYY')}.</div>}
        </div>
      </div>
    )
  }

  render() {
    const { apparel_info, extLeague, last_saved, selected_athlete, programUDFS, lists, selected_program } = this.state
    const organization_merch = Array.isArray(this.state.organization_merch) ? this.state.organization_merch : []
    const participantRows = (lists || []).reduce((acc, list) => {
      if (list && Array.isArray(list.items)) {
        acc.push(...list.items.map((item) => ({
          ...item,
          group: list.name || 'Unassigned',
        })))
      }
      return acc
    }, [])

    var AutoAssignShow = true
    lists.forEach( team => {
      if(team.team_type && team.team_type === 'Club Team' && team.clubteam_info && team.clubteam_info.finalized === true){
      AutoAssignShow = false
      }
    })

    var player_udfs = []
    const rosterSubtitleParts = [
      selected_program && selected_program.group_name ? selected_program.group_name : null,
      selected_program && selected_program.ages ? selected_program.ages : null,
      selected_program && (selected_program.gender || selected_program.division) ? (selected_program.gender || selected_program.division) : null,
    ].filter(Boolean)
    const messagingConversations = [
      {
        conversation_key: `${this.state.program_id}:Participants`,
        group_name: 'Participants',
        program_id: this.state.program_id,
        label: 'Participants',
      },
      ...(lists || [])
        .filter((list) => list && list.name && String(list.name).trim().toLowerCase() !== 'participants')
        .map((list) => ({
          conversation_key: `${this.state.program_id}:${list.name}`,
          group_name: list.name,
          program_id: this.state.program_id,
          label: list.name,
        })),
    ].filter((conversation, index, array) => array.findIndex((item) => item.conversation_key === conversation.conversation_key) === index)
    const selectedMessagingConversation = messagingConversations.find((conversation) => conversation.conversation_key === this.state.selected_group_conversation_key) || messagingConversations[0] || null

    if (selected_athlete && selected_athlete.udfs && programUDFS) {
      selected_athlete.udfs.forEach(udf => {
        var key = programUDFS.find(programUDF => { return udf.key === programUDF.key })
        if (key) { 
          player_udfs.push(<p key={makeUniqueKey()}>{key.label}: {udf.value}</p>)
        }
      })
    }
    return (
      <div className="full-page roster-page-shell">
        <HamburgerNavbar backHref={window.location.origin + "/programRosters?jwt=" + this.state.token} backLabel="Back to Rosters" />
        <div className="body-wrapper">
          <div className="search-page-wrapper programs-page-wrapper">
            <div className="programs-page-hero">
              <div className="programs-page-copy">
                <div className="programs-page-kicker">Admin Console</div>
                <h2 className="pagetitle programs-page-title">
                  <span>Roster Details</span>
                </h2>
                <div className="roster-page-subtitle">
                  {rosterSubtitleParts.length ? rosterSubtitleParts.join(' | ') : 'Program roster'}
                </div>
              </div>

              <div className="programs-page-stats roster-page-summary">
                <EnrolmentPanel enrolmentNumber={this.state.enrolmentData} />
                {last_saved === "" ? "" : (
                  <div className="roster-page-last-saved">
                    last saved at {last_saved.getHours()}:{last_saved.getMinutes()}:{last_saved.getSeconds()}
                  </div>
                )}
              </div>
            </div>

            <div className="roster-view-switcher">
              <button
                type="button"
                className={this.state.rosterView === 'participants' ? 'roster-view-switcher-btn active' : 'roster-view-switcher-btn'}
                onClick={() => this.setState({ rosterView: 'participants' }, () => this.persistRosterView('participants'))}
              >
                Participants
              </button>
              <button
                type="button"
                className={this.state.rosterView === 'teamBoard' ? 'roster-view-switcher-btn active' : 'roster-view-switcher-btn'}
                onClick={() => this.setState({ rosterView: 'teamBoard' }, () => this.persistRosterView('teamBoard'))}
              >
                Team Board
              </button>
              <button
                type="button"
                className={this.state.rosterView === 'messaging' ? 'roster-view-switcher-btn active' : 'roster-view-switcher-btn'}
                onClick={() => this.setState({ rosterView: 'messaging' }, () => this.persistRosterView('messaging'))}
              >
                Messaging
              </button>
              <button
                type="button"
                className={this.state.rosterView === 'rsvp' ? 'roster-view-switcher-btn active' : 'roster-view-switcher-btn'}
                onClick={() => this.setState({ rosterView: 'rsvp' }, () => this.persistRosterView('rsvp'))}
              >
                RSVPs
              </button>
            </div>

            <div className="roster-view-panel">
              {this.state.rosterView === 'participants' ? (
                <RosterParticipantsGrid
                  participants={participantRows}
                  onSelectParticipant={this.openAthleteModal}
                />
              ) : this.state.rosterView === 'teamBoard' ? (
                this.renderRosterBoard()
              ) : this.state.rosterView === 'rsvp' ? (
                this.renderRsvpView(participantRows, selected_program)
              ) : (
                <div className="roster-group-messaging">
                  <div className="parent-portal-section-title">Messaging</div>
                  {messagingConversations.length ? (
                    <div className="parent-portal-row">
                      <FormControl
                        className="opaque-grey selector padded"
                        id="selected_group_conversation"
                        componentClass="select"
                        value={selectedMessagingConversation ? selectedMessagingConversation.conversation_key : ''}
                        onChange={(event) => this.setState(
                          { selected_group_conversation_key: event.target.value },
                          () => this.persistRosterConversationKey(event.target.value)
                        )}
                      >
                        {messagingConversations.map((conversation) => (
                          <option key={conversation.conversation_key} value={conversation.conversation_key}>
                            {conversation.label}
                          </option>
                        ))}
                      </FormControl>
                    </div>
                  ) : null}
                  <div className="parent-portal-row">
                    {selectedMessagingConversation ? (
                      <AthleteMessagesPanel
                        key={selectedMessagingConversation.conversation_key}
                        conversationType="group"
                        conversationKey={selectedMessagingConversation.conversation_key}
                        conversationLabel={selectedMessagingConversation.label}
                        programId={selectedMessagingConversation.program_id}
                        groupName={selectedMessagingConversation.group_name}
                        organizationId={this.state.organization_id}
                        token={this.state.token}
                        currentUserType="admin"
                        visible={true}
                        panelTitle="Messaging"
                      />
                    ) : (
                      <div className="parent-portal-empty">No team conversations were found for this program yet.</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div>
            <Modal dialogClassName="" show={this.state.player_modal} onHide={() => this.handleModal('player_modal')} style={{borderRadius: 'none'}}>
              <Modal.Body style={{borderRadius: 'none'}}>

                {/* <Col sm={2} className="pull-right" style={{textAlign: "right"}}>
                  <a onClick={()=> this.handleModal('player_modal')}><FontAwesomeIcon icon={faTimes} size="1x" color='white' /></a>
                </Col> */}

                <div className="roster-player-modal-content">
                  <div className="roster-player-modal-top-row">
                    <h3>
                      {selected_athlete && `${selected_athlete.first_name} ${selected_athlete.last_name}`}
                    </h3>
                    {selected_athlete && <span className="roster-player-details-status">{selected_athlete.status || 'Enrolled'}</span>}
                  </div>
                  <section className="roster-player-details-card">
                    <h4 className="roster-player-section-heading">Participant details</h4>
                    {selected_athlete && (
                      <div className="roster-player-details-grid">
                        <div><span>Gender</span><strong>{selected_athlete.gender || '-'}</strong></div>
                        <div><span>Date of birth</span><strong>{selected_athlete.DOB || '-'}</strong></div>
                        <div><span>Email</span><strong>{selected_athlete.email || '-'}</strong></div>
                        <div><span>Phone</span><strong>{selected_athlete.parent_phone || '-'}</strong></div>
                        <div><span>Parent</span><strong>{selected_athlete.parent_name || '-'}</strong></div>
                        <div><span>Parent email</span><strong>{selected_athlete.parent_email || '-'}</strong></div>
                        <div><span>Address</span><strong>{selected_athlete.address || '-'}</strong></div>
                        <div><span>School</span><strong>{selected_athlete.current_school || '-'}</strong></div>
                      </div>
                    )}
                  </section>

                  {player_udfs.length > 0 && (
                    <section className="roster-player-secondary-card">
                      <div className="roster-player-details-kicker">Custom fields</div>
                      <div className="roster-player-udfs-grid">{player_udfs}</div>
                    </section>
                  )}

                  {selected_athlete && (
                    <section className="roster-player-secondary-card roster-player-notes-card">
                      <div className="roster-player-details-kicker">Notes</div>
                      <strong>{selected_athlete.notes || '-'}</strong>
                    </section>
                  )}

                  {!extLeague && (
                    <div className="roster-player-action-columns">
                      <section className="roster-player-action-card">
                        <div className="roster-player-action-kicker">Action 1</div>
                        <h4>Status update</h4>
                        <p className="roster-player-action-copy">Update this participant's status in the current program.</p>
                        <FormGroup>
                          <ControlLabel>Status</ControlLabel>
                          <FormControl className="opaque-grey" componentClass="select" id="status" value={this.state.selectedStatus || ''} onChange={(e) => this.setState({ selectedStatus: e.target.value })}>
                            {this.state.status_options}
                          </FormControl>
                        </FormGroup>
                        {this.state.status_spinner ? <div className="enrolment-loader"></div> : (
                          <Button className="rostersbutton" bsStyle="primary" onClick={() => this.handleAthleteStatusSubmit()}>
                            Update status
                          </Button>
                        )}
                      </section>

                      <section className="roster-player-action-card">
                        <div className="roster-player-action-kicker">Action 2</div>
                        <h4>Transfer</h4>
                        <p className="roster-player-action-copy">Move or copy this participant to another program and team.</p>
                        <FormGroup>
                          <div className="roster-player-field-label">
                            <ControlLabel>Action</ControlLabel>
                            <a className="hint-tip" onClick={() => this.setState({ transferTypeHint: !this.state.transferTypeHint })}>
                              <FontAwesomeIcon icon={faInfoCircle} color="currentColor" />
                              {this.state.transferTypeHint && (
                                <div className="hint-tip-text" id="transfer-type-hint">
                                  <span>Move removes the participant from this program. Copy keeps them here and adds them to the other program.</span>
                                </div>
                              )}
                            </a>
                          </div>
                          <FormControl className="opaque-grey" componentClass="select" id="transfer-type" value={this.state.transferType || ''} onChange={(e) => this.setState({ transferType: e.target.value })}>
                            <option key="select-action" value="" disabled>---</option>
                            <option key="move" value="move">Move</option>
                            <option key="copy" value="copy">Copy</option>
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Program</ControlLabel>
                          <FormControl className="opaque-grey" componentClass="select" id="transfer" onChange={(e) => this.selectProgramTransfer(e.target.value)}>
                            {this.getTransferProgramOptions()}
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Team</ControlLabel>
                          <FormControl className="opaque-grey" componentClass="select" id="team-transfer" value={this.state.teamIndex !== null ? this.state.teamIndex : ''} onChange={(e) => this.selectTeamTransfer(e.target.value)}>
                            {this.state.team_options}
                          </FormControl>
                        </FormGroup>
                        {this.state.transfer_spinner ? <div className="enrolment-loader"></div> : (
                          <Button className="rostersbutton" bsStyle="primary" onClick={() => this.handleTransferPlayer()}>
                            Transfer participant
                          </Button>
                        )}
                      </section>
                    </div>
                  )}

                  <div className="roster-player-modal-footer">
                    <Button className="cancel-option" onClick={() => this.handleModal('player_modal')}>Close</Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
          <div>
            <Modal dialogClassName="wide-modal" show={this.state.show_apparel_modal} onHide={() => this.handleModal("show_apparel_modal")}>
              <Modal.Body>
                <Row>
                  <Col sm={5}>
                    <h3>Roster Details</h3>
                  </Col>
                  <Col sm={2} className="pull-right" style={{textAlign: "right"}}>
                    <a onClick={() => this.handleModal("show_apparel_modal")}><FontAwesomeIcon icon={faTimes} size="1x" color='black' /></a>
                  </Col>
                </Row>
                <Table className="apparelTable" responsive>
                  <thead>
                    <tr>
                      {
                        extLeague && 
                        <Fragment>
                          <th className="player-info-tr">Organization</th>
                          <th className="player-info-tr">Team</th>
                        </Fragment>
                      }
                      <th>Status</th>
                      <th>Name</th>
                      <th className="hidePhone">Email</th>
                      <th>Plan Name</th>
                      {
                        organization_merch.length !== 0 && !extLeague &&
                        <Fragment>
                          <th className="hidePhone">{organization_merch[0] ? organization_merch[0].name:""}</th>
                          <th className="hidePhone">{organization_merch[1] ? organization_merch[1].name:""}</th>
                          <th className="hidePhone">{organization_merch[2] ? organization_merch[2].name:""}</th>
                        </Fragment>
                      }
                      <th>Parent</th>
                      <th>Phone</th>
                      <th>Secondary Name</th>
                      <th>Secondary Phone</th>
                      <th className="hidePhone">Current School</th>
                      <th className="hidePhone">Enrolment Notes</th>
                      {
                        programUDFS &&
                        programUDFS.map(udf => 
                          <th className="hidePhone" key={makeUniqueKey()}>{udf.label}</th>
                        )
                      }
                    </tr>
                  </thead>
                  <tbody>
                  {
                  apparel_info.map((data, index) =>
                    <tr className={index % 2 === 0? "apparel_even": "apparel_odd"} key={makeUniqueKey()}>
                      {
                        extLeague &&
                        <Fragment>
                          <td className="player-info-td">{data.org}</td>
                          <td className="player-info-td">{data.team}</td>
                        </Fragment>
                      }
                      <td className="player-info-td">{data.status}</td>
                      <td className="player-info-td">{data.first_name} {data.last_name}</td>
                      <td className="player-info-td">{data.email}</td>  
                      <td className="hidePhone player-info-td">{data.plan_name}</td>
                      {
                        data.merch && !extLeague &&
                        <Fragment>
                          <td className="hidePhone player-info-td">{data.merch.item_0 ? data.merch.item_0: '-'}</td>
                          <td className="hidePhone player-info-td">{data.merch.item_1 ? data.merch.item_1: '-'}</td>
                          <td className="hidePhone player-info-td">{data.merch.item_2 ? data.merch.item_2: '-'}</td>
                        </Fragment>
                      }
                      <td className="player-info-td">{data.parent_name}</td>
                      <td className="player-info-td">{data.parent_phone}</td>
                      {
                        data.secondary ?
                        <Fragment>
                          <td className="player-info-td">{data.secondary.first_name} {data.secondary.last_name}</td>
                          <td className="player-info-td">{data.secondary.phone}</td>
                        </Fragment>
                        :
                        <Fragment>
                          <td>-</td>
                          <td>-</td>
                        </Fragment>
                      }
                      <td className="player-info-td">{data.current_school}</td>
                      <td className="player-info-td">{data.notes}</td>
                      {
                      programUDFS && this.state.show_apparel_modal &&
                        programUDFS.map(programUDF => {
                          if (data.udfs) { // athlete has UDFs attach to profile
                            var udf = data.udfs.find(playerUDF => { return playerUDF.key === programUDF.key })
                            if (udf) { 
                              return <td key={makeUniqueKey()} className="player-info-td">{udf.value}</td>
                            } else {
                              return <td key={makeUniqueKey()} className="player-info-td">-</td>
                            }
                          } else {  // athlete doesn't have UDFs attached, add them.
                            var getAthleteUDFs = this.findAthleteDetails(data)
                            var athleteUdf = getAthleteUDFs ? getAthleteUDFs.find(playerUDF => { return playerUDF.key === programUDF.key }) : null
                            if (athleteUdf) {
                              return <td key={makeUniqueKey()} className="player-info-td">{athleteUdf.value}</td>
                            } else {
                              return <td key={makeUniqueKey()} className="player-info-td">-</td>
                            }
                          }
                        })
                      }
                    </tr>
                  )}
                  </tbody>
                </Table>
                <Row className="btn-flex hidePhone">
                  <Col sm={2} style={{textAlign:"center"}}>
                    <div className="modalbtns">                        
                      <a className="button2" onClick={()=> this.handleModal('show_apparel_modal')}>Cancel</a>
                    </div>                     
                  </Col>
                </Row>
              </Modal.Body>
            </Modal>
          </div>
          <div>
          <Modal dialogClassName="apparel-modal white-text" show={this.state.link_modal} onHide={()=> this.handleModal('link_modal')}>
            <Modal.Body>
 
              {/* <Row>
                <Col lg={12} sm={8}>
                  <h3>Enrolment Form Link</h3>
                </Col>
                <Col sm={2} className="pull-right" style={{textAlign: "right"}}>
                  <a onClick={() => this.handleModal('link_modal')}><FontAwesomeIcon icon={faTimes} size="1x" color='white' /></a>
                </Col>
              </Row> */}

              <div className="enrolment-links margin-2">
                <p className="link" style={{ padding: '10px 1em', fontSize: 'large'}}>Links
                <a className="hint-tip" style={{paddingRight: '1em'}} onClick={() => this.setState({ linkHint: !this.state.linkHint })}>
                <FontAwesomeIcon icon={faInfoCircle} color='white' size="sm"/>
                {
                  this.state.linkHint &&
                  <div className="hint-tip-text" id="name-hint">
                    <span>Copy and use these urls to register people for this event.</span>
                  </div>
                }
              </a>                
                
                </p>
                
                <div className="margin-2" style={{marginTop: "0"}}>
                  <p className="link">Long Link</p>
                  <div className="search-bar" style={{boxShadow: 'none'}}>
                    <div style={{width: '100%'}}>
                      <input type="text" name="filter" className="searchButton" readOnly value={this.state.newLink} />
        </div>
      </div>
                </div>
                {/*<div className="margin-2">*/}
                {/*  <p className="white-text link">Short Link</p>*/}
                {/*  <div className="search-bar" style={{boxShadow: 'none'}}>*/}
                {/*    <div style={{width: '100%'}}>*/}
                {/*      <input type="text" name="filter" className="searchButton" readOnly value={this.state.newShortLink}/>*/}
                {/*    </div>*/}
                {/*  </div>  */}
                {/*</div>  */}
              </div>
              <Row className="btn-flex hidePhone">
                <Col sm={2} style={{textAlign:"center"}}>
                  <Button className="rostersbutton" type="button" onClick={() => this.handleModal('link_modal')}>Close</Button>
                  
                </Col>
              </Row>

            </Modal.Body>
          </Modal>
          </div>
        </div>
    </div>
    )
  }
}

export default Board;
